import type { GetEventNamesResponse } from '@vy/api-definition';
import { GetEventNamesResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useEventNames(options?: CustomUseQueryOptions<GetEventNamesResponse>) {
  return useQuery(
    queryKeys.eventNames(),
    async () => {
      const privateApi = getPrivateApi();
      const getEventNamesResponse = await privateApi.getEventNames();

      return GetEventNamesResponseSchema.parse(getEventNamesResponse);
    },
    options,
  );
}
